<section class="pt-4">
  <h2 class="user-select-none">Objects</h2>
  <p class="user-select-none">The object is flexible you may use it for a bar, host stand, dividers, etc.</p>

  <div class="tablesready-objects background-hover">
    <div class="tablesready-object">
      <div
        class="tablesready-objects-rectangular drag-table"
        [class.disabled]="disabled"
        (mousedown)="dragElement($event, shapes.rectangular)"
        (touchstart)="dragElement($event, shapes.rectangular)"
      >
        <p class="mb-0 user-select-none">Label</p>
      </div>
    </div>

    <div class="tablesready-object">
      <div
        class="tablesready-objects-circle drag-table"
        [class.disabled]="disabled"
        (mousedown)="dragElement($event, shapes.circle)"
        (touchstart)="dragElement($event, shapes.circle)"
      >
        <p class="mb-0 user-select-none">Label</p>
      </div>
    </div>
  </div>
</section>
